<template>
  <div
    class="grid grid-cols-1 xs:grid-cols-3 xs:grid-rows-2 gap-3 sm:gap-4 lg:gap-x-8 my-6 px-4 lg:px-0"
  >
    <SkeletonPlaceholder
      v-for="count in 6"
      :key="count"
      class="h-10"
      shape="rectangle"
      bgClass="bg-body-checkout-sidebar"
    />
  </div>
</template>

<script setup lang="ts">
import SkeletonPlaceholder from '@/common/components/atoms/SkeletonPlaceholder.vue'
</script>
